import * as PIXI from 'pixi.js'
import shaderSource from './PastelFilter.glsl'

export default class CustomFilter extends PIXI.Filter {

  constructor () {
    super()
    const sampleCount = 25
    const angleStep = (Math.PI * 2 / sampleCount).toFixed(7)
    // console.log(shaderSource.replace(/<ANGLE_STEP>/g, angleStep))
    super(
      null, // vertex shader
      shaderSource.replace(/<ANGLE_STEP>/g, angleStep)
      , // fragment shader
      // uniforms
      {
        uSize: new Float32Array([0, 0]),
        uShColor1: new Float32Array([0.3, 0.1, 0.0]),
        uShColor2: new Float32Array([0.3, 0.1, 0.0]),
        uThickness: 24.0,
        uRotate: 0.0
      }
    )
  }

  apply(filterManager, input, output, clear) {
    const thickness = this.uniforms.uThickness
    this.uniforms.uSize[0] = thickness / input._frame.width;
    this.uniforms.uSize[1] = thickness / input._frame.height;
    filterManager.applyFilter(this, input, output, clear);
  }

  private colorNumToVec(c: number): Float32Array {
    return new Float32Array([
      /* R */ ((c & 0b1111_1111_0000_0000_0000_0000) >> (4 * 4)) / 0xff,
      /* G */ ((c & 0b0000_0000_1111_1111_0000_0000) >> (4 * 2)) / 0xff,
      /* B */ ((c & 0b0000_0000_0000_0000_1111_1111)) / 0xff
    ])
  }

  set shColor1 (c: number) {
    const arr = this.colorNumToVec(c)
    for(let i = 0; i < 3; i++) this.uniforms.uShColor1[i] = arr[i]
    console.log(arr)
  }
  set shColor2 (c: number) {
    const arr = this.colorNumToVec(c)
    for(let i = 0; i < 3; i++) this.uniforms.uShColor2[i] = arr[i]
   }

  set thickness(v: number) {
    this.uniforms.uThickness = v
  }
}
